import SlsTipoPedidoEstabClassifiscClient from '@/api/SistemaDKP/sls-tipo-pedido-estab-classifisc.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSTipoPedidoEstabClassifiscService {
  constructor() {
    this.client = new SlsTipoPedidoEstabClassifiscClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.findTipopedidoEndEstabelecimento(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os tipo pedido estab');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Tipo Pedido Estab');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Tipo Pedido Estab');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Tipo Pedido Estab');
    }
  }

  async destroy(data) {
    try {
      const { data: response } = await this.client.destroy(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Tipo Pedido Estab');
    }
  }
}
